<template>
    <div id="propertyedit_main" :class="open ? 'propertyedit_main_open shadow-1' : ''">
        <div id="propertyedit_head" class="bt bt-hover-dark" :class="open ? 'bg-white' : 'bg-white'" @click="openBody">
            <div v-if="!open" class="fs-small">
                <span class="fc-main">{{ data.name }}</span>: <span>{{ data.value }}</span>
            </div>
            <div v-else class="fs-small fw-bold">
                <span>Edit Property</span>
            </div>
            <div>
                <i v-if="open" id="propertyedit_delete" class="fas fa-trash fc-gray-dark " @click="api_delete_property"></i>
                <i v-if="open" class="fas fa-chevron-up fc-gray-dark"></i>
                <i v-else class="fas fa-chevron-down fc-gray-dark"></i>
            </div>
        </div>
        <div v-if="open" id="propertyedit_body">
            <div id="propertyedit_name">
                <label for="propertyedit_name_input" class="fs-small">Name</label>
                <input id="propertyedit_name_input" type="text" class="bg-faded fs-small" v-model="propertyName">
            </div>
            <div id="propertyedit_value">
                <label for="propertyedit_value_input" class="fs-small">Value</label>
                <input id="propertyedit_value_input" type="text" class="bg-faded fs-small" v-model="propertyValue">
            </div>
            <datatypes-dropdown v-model="propertyDataType" :selected-id="propertyDataType"></datatypes-dropdown>
            <div id="propertyedit_settings">
                <button :disabled="!changed" id="propertyedit_settings_save" class="fc-white fs-normal ff-varela bt bt-normal bg-main bt-hover-light" @click="api_update_property">Save</button>
            </div>
        </div>
    </div>
</template>

<script>
  import CustomInput from '../miscellaneous/customInput'
  import CustomDropdown from '../miscellaneous/customDropdown'
  import DatatypesDropdown from './datatypesDropdown'
  export default {
    name: 'propertyEdit',
    components: { DatatypesDropdown, CustomDropdown, CustomInput },
    props: {
      data: {
        type: Object
      },
      open: {
        type: Boolean
      }
    },
    data(){
      return{
        propertyName: this.data.name,
        propertyValue: this.data.value,
        propertyDataType: this.data.datatypeId
      }
    },
    computed: {
      changed(){
        return (this.propertyName !== this.data.name || this.propertyValue !== this.data.value)
      }
    },
    methods: {
      openBody(){
        !this.open ? this.$emit('open') : this.$emit('close')
      },
      api_delete_property(){
        this.$emit('deleteProperty', {id: this.data.id})
      },
      api_update_property(){
        this.$emit('updateProperty', {id: this.data.id, name: this.propertyName, value: this.propertyValue, datatype: this.propertyDataType})
      }
    }
  }
</script>

<style scoped>
    #propertyedit_main{
        display: flex;
        width: 100%;
        flex-direction: column;
    }
    .propertyedit_main_open{
        display: flex;
        margin: 10px;
        width: calc(100% - 20px)!important;
    }
    #propertyedit_head{
        display: flex;
        padding: 10px;
        width: calc(100% - 20px);
        #border-bottom: 1px solid var(--color-gray);
        justify-content: space-between;
        align-items: center;
        height: 25px;
    }
    #propertyedit_body{
        display: flex;
        width: calc(100% - 20px);
        margin-left: 10px;
        margin-top: 5px;
        margin-bottom: 20px;
        flex-direction: column;
    }
    #propertyedit_name,
    #propertyedit_value{
        display: flex;
        width: calc(100% - 10px);
        flex-direction: column;
    }
    #propertyedit_name_input,
    #propertyedit_value_input{
        display: flex;
        width: 100%;
        height: 20px;
        padding: 5px;
        margin-bottom: 10px;
        border: 1px solid var(--color-gray);
    }
    #propertyedit_save,
    #propertyedit_delete{
        margin-right: 10px;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    #propertyedit_settings{
        display: flex;
        width: 100%;
    }
    #propertyedit_settings_save{
        display: flex;
        margin-left: auto;
        margin-top: 10px;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 5px;
        padding-bottom: 5px;
        cursor: pointer;
    }
</style>
